// Discover the fire of Fogo block js
document.addEventListener("DOMContentLoaded", () => {
    const cards = document.querySelectorAll(".menu-card");
    let observer = null; 
    let currentBehavior = null;

    function ensurePlaysInline() {
        cards.forEach((card) => {
            const video = card.querySelector(".card-video");
            if (video) {
                video.setAttribute("playsinline", "true");
                video.setAttribute("muted", "true");
            }
        });
    }

    function resetVideos() {
        cards.forEach((card) => {
            const video = card.querySelector(".card-video");
            video.pause();
            video.currentTime = 0;
        });
    }

    function addHoverEvents() {
        cards.forEach((card) => {
            const video = card.querySelector(".card-video");
            const overlay = card.querySelector(".video-overlay");

            card.addEventListener("mouseenter", () => {
                video.play();
                if (overlay) {
                    overlay.classList.add("active");
                }
            });

            card.addEventListener("mouseleave", () => {
                video.pause();
                video.currentTime = 0; 
                video.load(); 
                if (overlay) {
                    overlay.classList.remove("active");
                }
            });
        });
    }

    function addScrollEvents() {
        const observerOptions = {
            root: null, 
            threshold: 0.5, 
        };

        observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const video = entry.target.querySelector(".card-video");

                if (entry.isIntersecting && !video.isPlaying) {
                    video.currentTime = 0; 
                    video.play();
                    video.isPlaying = true;

                    video.addEventListener(
                        "ended",
                        () => {
                            video.pause();
                            video.isPlaying = false;
                        },
                        { once: true }
                    );
                } else if (!entry.isIntersecting) {
                    video.pause();
                    video.currentTime = 0;
                    video.isPlaying = false;
                }
            });
        }, observerOptions);

        cards.forEach((card) => observer.observe(card));
    }

    function clearObserver() {
        if (observer) {
            observer.disconnect();
            observer = null;
        }
    }

    function setBehaviorBasedOnViewport() {
        const isMobileView = window.innerWidth <= 1024;

        if (isMobileView && currentBehavior !== "mobile") {
            clearObserver(); 
            resetVideos(); 
            addScrollEvents();
            ensurePlaysInline();
            currentBehavior = "mobile";
        } else if (!isMobileView && currentBehavior !== "desktop") {
            clearObserver(); 
            resetVideos(); 
            addHoverEvents();
            currentBehavior = "desktop";
        }
    }

    ensurePlaysInline();
    setBehaviorBasedOnViewport();

    window.addEventListener("resize", () => {
        setBehaviorBasedOnViewport();
    });
});
